import { api } from "./api";
import { Customer } from "@/types/customer";
import log from "../utils/logger";

export const getCustomerByName = async (name: string): Promise<Customer> => {
  try {
    const response = await api.get(`/customer/name/${name}`);
    return response.data.body;
  } catch (error) {
    log.error("Error fetching customer:", undefined, error);
    throw error;
  }
};
